import AUTH from "./auth"
import ENDPOINTS from "./endpoints"
import FRONTEND_ROUTES from "./front-end-routes"
import HTTP_STATUS_CODE from "./http-status-code"
import KEY_VALUES from "./key-values"
import PERMISSIONS from "./permission-roles"
import SIDEBAR_LINKS from "./sidebar-links"
import VERSION from "./version"
const BASE_URL = import.meta.env.VITE_API_URL
if (!BASE_URL) {
  throw new Error(
    "VITE_API_URL não está definida. Verifique o Jenkins/.env",
  )
}
export {
  AUTH,
  BASE_URL,
  ENDPOINTS,
  FRONTEND_ROUTES,
  HTTP_STATUS_CODE,
  KEY_VALUES,
  PERMISSIONS,
  SIDEBAR_LINKS,
  VERSION,
}
